export const toCamel = (s: string): string =>
  s.replace(/([_][a-z])/gi, (str) => str.toUpperCase().replace('_', ''))

export const toCapitalize = (s: string): string =>
  s[0].toUpperCase() + s.slice(1)
